var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.sdaData && !_vm.onlyShowSDAInv)?_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-card',[_c('v-card-text',[_c('div',{staticClass:"text-subtitle-1"},[_vm._v(" Προς: "+_vm._s(_vm.sdaData.client.PartnerBrandName)+" ")]),_c('div',{staticClass:"text-subtitle-2"},[_vm._v(" "+_vm._s(_vm.sdaData.client.BranchAddress)+" ")])])],1)],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }